import { render, staticRenderFns } from "./requests-fees-estimation-modal.vue?vue&type=template&id=cb89363e&scoped=true&"
import script from "./requests-fees-estimation-modal.vue?vue&type=script&lang=js&"
export * from "./requests-fees-estimation-modal.vue?vue&type=script&lang=js&"
import style0 from "./requests-fees-estimation-modal.vue?vue&type=style&index=0&id=cb89363e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb89363e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
